// Service Worker Registration
// — A new build activates as soon as it downloads (see service-worker.js)
// — Checks for a new build when the app comes back to the foreground, and hourly
// — Reloads automatically, unless the user has typed into a form — then a
//   toast offers the refresh so nothing they typed is lost

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

const UPDATE_CHECK_MS = 60 * 60 * 1000;

// True when an input/textarea holds something the user typed (search boxes excluded).
function hasUnsavedInput() {
  const fields = document.querySelectorAll(
    'textarea, input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=search]):not([type=submit]):not([type=button])'
  );
  return Array.from(fields).some((el) => !el.readOnly && !el.disabled && el.value && el.value !== el.defaultValue);
}

function reloadForUpdate() {
  if (hasUnsavedInput()) {
    showUpdateToast();
  } else {
    window.location.reload();
  }
}

function registerValidSW(swUrl, config) {
  // A controller change on the very first visit is just the first install — not an update.
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    reloadForUpdate();
  });

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // A worker left waiting by an older build (which required a tap) — activate it now.
      if (registration.waiting && navigator.serviceWorker.controller) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Installed apps resume from the background without a page load, so the
      // browser never re-checks on its own — check whenever the app is shown again.
      const checkForUpdate = () => registration.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdate();
      });
      setInterval(checkForUpdate, UPDATE_CHECK_MS);

      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;

        installing.onstatechange = () => {
          if (installing.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // New version installed — it activates itself and 'controllerchange' reloads.
            if (config && config.onUpdate) config.onUpdate(registration);
          } else {
            // First install — app is now cached for offline use
            if (config && config.onSuccess) config.onSuccess(registration);
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });
}

function showUpdateToast() {
  // Avoid duplicate toasts
  if (document.getElementById('sw-update-toast')) return;

  const toast = document.createElement('div');
  toast.id = 'sw-update-toast';
  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: '#0f2550',
    color: '#fff',
    padding: '12px 20px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.40)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    zIndex: '99999',
    fontSize: '14px',
    fontWeight: '600',
    border: '1px solid rgba(74,144,232,0.40)',
    whiteSpace: 'nowrap',
  });

  toast.innerHTML = `
    <span>🔄 Verisiyo nshya irahari</span>
    <button id="sw-update-btn" style="
      background:#4a90e8; color:#fff; border:none;
      padding:6px 14px; border-radius:8px;
      font-weight:700; font-size:13px; cursor:pointer;">
      Vugurura
    </button>
    <button id="sw-dismiss-btn" style="
      background:none; color:rgba(255,255,255,0.55); border:none;
      font-size:18px; cursor:pointer; padding:0 4px; line-height:1;">
      ×
    </button>
  `;

  document.body.appendChild(toast);

  // The new version is already active — reloading is all that's left.
  document.getElementById('sw-update-btn').onclick = () => window.location.reload();

  document.getElementById('sw-dismiss-btn').onclick = () => toast.remove();
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && !contentType.includes('javascript'))
      ) {
        navigator.serviceWorker.ready.then((reg) => {
          reg.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Offline mode — no internet connection.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch((err) => console.error(err.message));
  }
}
